import { Box } from "@mui/material";
import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";
import { ArrowLink, PrimaryButton } from "../ui/primitives";
import PageHero from "../widgets/PageHero";

export function NotFound() {
    const { t } = useTranslation("Common");
    return (
        <>
            <Helmet>
                <title>{`404 · ${t("notFound.title")}`}</title>
                <meta name="robots" content="noindex" />
            </Helmet>
            <PageHero eyebrow="404" title={t("notFound.title")} lead={t("notFound.body")}>
                <Box sx={{ mt: 5, display: "flex", flexWrap: "wrap", alignItems: "center", gap: 3 }}>
                    <PrimaryButton to="/">{t("notFound.home")}</PrimaryButton>
                    <ArrowLink to="/ourwork">{t("nav.work")}</ArrowLink>
                    <ArrowLink to="/contact">{t("nav.contact")}</ArrowLink>
                </Box>
            </PageHero>
        </>
    );
}
